import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import VideoCard from "@/components/base/VideoCard";
import CategoryNav from "@/pages/home/components/CategoryNav";
import { getVideosByCategory } from "@/mocks/videos";
import { getCategoryBySlug, categories } from "@/mocks/categories";
import type { Video } from "@/mocks/videos";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const [videos, setVideos] = useState<Video[]>([]);
  const [activeSort, setActiveSort] = useState("hot");

  const category = getCategoryBySlug(slug || "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (slug) {
      let filtered = getVideosByCategory(slug);
      if (activeSort === "new") {
        filtered = [...filtered].sort((a, b) => b.updateDate.localeCompare(a.updateDate));
      } else if (activeSort === "score") {
        filtered = [...filtered].sort((a, b) => b.score - a.score);
      }
      setVideos(filtered);
    }
  }, [slug, activeSort]);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-20 text-center">
            <p className="text-foreground-500">分类不存在</p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: category.name },
            ]}
          />

          <div className="mb-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100">
                <i className={`${category.icon} text-lg`} style={{ color: "oklch(var(--primary-500))" }}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold" style={{ fontFamily: "var(--font-heading)", color: "oklch(var(--foreground-900))" }}>
                  {category.name}
                </h1>
                <p className="text-sm text-foreground-500 mt-0.5">共 {category.count}+ 部作品</p>
              </div>
            </div>

            <CategoryNav />

            <div className="flex items-center gap-2 mt-4">
              {[
                { key: "hot", label: "热门" },
                { key: "new", label: "最新" },
                { key: "score", label: "评分" },
              ].map((sort) => (
                <button
                  key={sort.key}
                  onClick={() => setActiveSort(sort.key)}
                  className={`px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
                    activeSort === sort.key
                      ? "bg-foreground-900 text-white"
                      : "bg-background-100 text-foreground-500 hover:bg-background-200"
                  }`}
                >
                  {sort.label}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-4 pb-12">
            {videos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
          {videos.length === 0 && (
            <div className="py-20 text-center">
              <p className="text-foreground-400">暂无内容</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}